<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" stroke="black"/>
<path d="M11.15 5.15L6.5 9.8L4.85 8.15C4.65 7.95 4.35 7.95 4.15 8.15C3.95 8.35 3.95 8.65 4.15 8.85L6.15 10.85C6.25 10.95 6.35 11 6.5 11C6.65 11 6.75 10.95 6.85 10.85L11.85 5.85C12.05 5.65 12.05 5.35 11.85 5.15C11.65 4.95 11.35 4.95 11.15 5.15Z"/>
</svg>
